<template>
	<div class="edit-profile change-password px30 pt-8 flex flex-col">
		<button v-ripple type="button" class="btn-empty-wrapper mr-5 mb-5" @click="clickHandler">
			<Close icon="back" />
		</button>
		<h3 class="page-title color-text font-bold text-28 text-text tracking-tight leading-tight mb-2">
			<span class="text-primary">{{ $t('Change') }}</span>
			<span class="text-secondary">{{ $t('Password') }}</span>
		</h3>
		<p class="text-12 tracking-normal text-text opacity-60">
			{{ $t("Enter your new password below, we're just being extra safe") }}
		</p>
		<div class="form-items form-with-icons pt-10 flex flex-col flex-grow" :class="{
			'form-enabled': values.password && values.confirm_password && values.old_password,
		}">
			<FormulateForm #default="{ hasErrors }" v-model="values">
				<FormulateInput v-for="item in schema" :key="item.name" v-bind="item" :hasErrors="hasErrors" />
			</FormulateForm>
		</div>
	</div>
</template>

<script>
import Close from '../UI/Close';
export default {
	name: 'ChangePassword',

	components: { Close },

	props: ['clickHandler'],

	data: function () {
		return {
			values: {
				password: '',
				confirm_password: '',
				old_password: '',
			},
			schema: [
				{
					type: 'toggablePassword',
					name: 'old_password',
					label: '.',
					placeholder: this.$t('Current Password'),
					validation: 'required',
				},
				{
					type: 'toggablePassword',
					name: 'password',
					label: '.',
					placeholder: this.$t('New Password'),
					validation: 'required|min:8,length|matches:/[0-9]/',
					'validation-messages': {
						matches: this.$t('At least 8 characters, 1 uppercase letter, 1 number, 1 symbol'),
					},
					help: this.$t('At least 8 characters, 1 uppercase letter, 1 number, 1 symbol'),
				},
				{
					type: 'toggablePassword',
					name: 'confirm_password',
					label: '.',
					placeholder: this.$t('Confirm Password'),
					validation: '^required|confirm:password',
					validationName: 'Password confirmation',
				},
				{
					type: 'customButton',
					label: this.$t('Save'),
					formHandler: this.formHandler,
				},
			],
		};
	},

	methods: {
		formHandler: function () {
			if (
				this.values.password &&
				this.values.confirm_password &&
				this.values.old_password &&
				this.values.password === this.values.confirm_password
			) {
				this.$http.post('user/changepassword', this.values).then((data) => {
					if (data && data.status !== undefined && data.status) {
						this.values = {
							password: '',
							confirm_password: '',
							old_password: '',
						};
						this.clickHandler();
					}
				});
			}
		},
	},
};
</script>
